<!-- ============================================================ -->
<!-- Checkbox Component Template — Design System (MIGRATED) -->
<!-- ============================================================ -->
<!-- ✅ Migrated to use component-specific classes with new design system -->
<!-- See libs/publishable/ui/styles/docs/04-MIGRATION_GUIDE.md -->
<!-- ============================================================ -->

<label class="p-checkbox-container" [ngClass]="{ disabled: disabled }">
    <span class="p-checkbox-input-wrapper">
        <!-- ✅ Accessibility pattern: checkbox element is hidden, styled with CSS -->
        <input
            type="checkbox"
            class="p-checkbox-input"
            [attr.aria-label]="ariaLabel"
            [checked]="checked"
            [disabled]="disabled"
            [indeterminate]="indeterminate"
            (change)="onValueChanged($event)"
        />
    </span>
    <span class="p-checkbox-label" [attr.automation-id]="label ? (label | toAutomationId: { suffix: '-label' }) : ''">{{ label }}</span>
</label>
